export default "__VITE_ASSET__BBG3dGvE__"